export default "__VITE_ASSET__jUUb7YcN__"